"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
const resolver_factory_1 = __importDefault(require("./resolver/resolver-factory"));
/**
 * {@link I18nConfigurationProvider} implementation that reads configuration
 * using the ACS offline client.
 */
class AcsOfflineI18nConfigurationProvider extends i18n_configuration_provider_1.I18nConfigurationProvider {
    resolveConfiguration(name, args) {
        return this.resolveConfigurationWithStage(name, args, i18n_configuration_provider_1.ConfigStage.PROD);
    }
    resolveConfigurationWithStage(name, args, configStage) {
        // I18nArgs can be more specific (i.e in case of Price Format).
        // Use the ConfigType as QueryResolvers are registered by specific ConfigTypes.
        const resolver = resolver_factory_1.default.getResolver(args.getConfigType(), configStage);
        return resolver.resolve(name, args);
    }
}
exports.default = AcsOfflineI18nConfigurationProvider;
//# sourceMappingURL=acs-offline-i18n-configuration-provider.js.map